/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{_ as s}from"../../../../../chunks/tslib.es6.js";import{autoDispose as t,AutoDisposable as i}from"../../lib/AutoDisposable.js";class o extends i{constructor(s,t,i,o){super(),this.primitiveType=t,this.parameters=i,this.indexed=o,this.vao=s}}s([t()],o.prototype,"vao",void 0);export{o as RenderGeometry};
